var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"loading":_vm.isLoading,"small":"","icon":"","color":"error"},on:{"click":_vm.submit}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(" fa-times ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }